import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { IAccount } from 'store/accounts.model';
import Loader from 'ui/Loader/Loader';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import Tabs from 'ui/Tabs/Tabs';
import accountsStore from 'store/accountsStore';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import { WarningModal } from 'components/modals';
import { TabsType } from './BankStatement.model';

import OfficialStatement from './tabs/OfficialStatement/OfficialStatement';
// import EStatement from './tabs/EStatement/Estatement';

const tabsOptions = [
  { label: 'Official Statement' },
  // { label: 'E-Statement' },
];

const BankStatement = () => {
  const [accountsState, setAccountsState] = useState<IAccount[]>([]);
  const [activeTab, setActiveTab] = useState<TabsType>(0);
  const [nextTab, setNextTab] = useState<TabsType>(0);
  const [loadingData, setLoadingData] = useState(false);

  const [isFormDirty, setFormDirty] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const { accounts } = accountsStore;

  useEffect(() => setAccountsState(accounts), [accounts]);

  const location = useLocation<{ tab: TabsType }>();

  useEffect(() => {
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
    if (location.state) {
      setActiveTab(location.state.tab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downMdScreen]);

  useEffect(() => {
    const fetchAccounts = () => {
      if (accounts.length) {
        // accounts loaded already
        return Promise.resolve();
      }
      return accountsStore.fetchAccounts();
    };

    setLoadingData(true);

    Promise.all([fetchAccounts()]).finally(() => {
      setLoadingData(false);
    });
  }, []);

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: TabsType) => {
    setNextTab(tabIndex);

    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveTab(tabIndex);
    }
  };

  const handleClickBack = () => {
    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveTab(false);
    }
  };

  const onLeavePage = () => {
    setShowWarning(false);
    setFormDirty(false);
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
  };

  const closeWarning = () => setShowWarning(false);
  const switchDirtyTrue = () => setFormDirty(true);

  return (
    <DashboardCard fullHeight>
      <NavigationTitle
        to="/bankStatements"
        layoutType={LayoutType.dashboard}
        onClick={handleClickBack}
        noArrow={activeTab === false}
      >
        {activeTab === false || !downMdScreen ? 'Bank Statement' : tabsOptions[activeTab].label}
      </NavigationTitle>
      {downMdScreen && activeTab === false && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs value={activeTab} options={tabsOptions} onChange={handleOnChangeTab} />
      {loadingData ? <Loader /> : null}
      {!loadingData && activeTab === 0 && (
        <OfficialStatement accounts={accountsState} handleChangeForm={switchDirtyTrue} />
      )}
      {/* {!loadingData && activeTab === 1 && <EStatement />} */}
      <WarningModal open={showWarning} submitName="Leave Page" onSubmit={onLeavePage} onClose={closeWarning}>
        Entered data will be lost. Are you sure you want to leave page?
      </WarningModal>
    </DashboardCard>
  );
};

export default observer(BankStatement);
